<template>
   <span class="relative inline-flex items-center">
    <a  href="#" @click.prevent="showCartDrawer()" aria-label="cart-viewser">
        <div v-if="theme === 'light'">
            <ShoppingBagIconSolid class="text-liText-ternary-dark hover:text-gray-400 dark:text-liText-ternary-light dark:hover:text-liBorder-primary-light w-5" v-if="cartItemList && parseInt(cartItemList.length) > 0" />
            <ShoppingBagIconOutline class="text-liText-ternary-dark hover:text-gray-400 dark:text-liText-ternary-light dark:hover:text-liBorder-primary-light w-5" v-else />
            <div
                class="absolute inline-flex items-center justify-center w-6 h-6 text-sm font-bold text-liText-ternary-dark border-2 border-white bg-primary-light rounded-full -top-2 -right-2"
                v-if="cartItemList && parseInt(cartItemList.length) > 0">{{ cartItemList.length }}</div>
        </div>
        <div v-else>
            <ShoppingBagIconSolid class="text-gray-200 hover:text-gray-50 w-5" v-if="cartItemList.length > 0" />
            <ShoppingBagIconOutline class="text-gray-200 hover:text-gray-50 w-5" v-else />
            <div
                class="absolute inline-flex items-center justify-center w-6 h-6 text-sm font-bold text-black border-0 border-white bg-white rounded-full -top-2 -right-2"
                v-if="cartItemList && parseInt(cartItemList.length) > 0">{{ cartItemList.length }}</div>
        </div>
      </a>
    </span>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  import router from '@/router'
  import { ShoppingBagIcon as ShoppingBagIconOutline } from "@heroicons/vue/24/outline"
  import { ShoppingBagIcon as ShoppingBagIconSolid } from "@heroicons/vue/20/solid"
  
  export default {
    name: 'cart icon',
    props: {
    theme: {
      type: String,
      required: true,
    },
    },
    components: {
      ShoppingBagIconOutline,
      ShoppingBagIconSolid
    },
    methods: {
      async showCartDrawer() {
        router.push('#cart')
      },
    },
    computed: {
      ...mapGetters([
      'cartItemList'
      ]),
    },
  }
  </script>
  <style lang="scss" scoped />